export const points = [
  {
    name: "3x Lombard Lux",
    logo: "/points/lombard.svg",
    collateralVaults: [
      "0x1874f82AC9EF2Bd5603Cc946Cb6f3bCB9Dd2d66F",
      "0xbC5fd2cA51B0BCA8882246833B2ea8627A79bC59",
      "0xDb53E5C7578cFB52E72728c89BA895692e49Aa45",
    ],
  },
  {
    name: "3x Magma Points",
    logo: "/points/magma.svg",
    collateralVaults: [
      "0xd2f35c39A7187BBF55c0b05C52808d7A18eD62Ca",
      "0xb181030fF0767c24D83c65527BD42146486F415E",
      "0x9020DbCA5a8CCfaB6116123e308204a44A5b93D4",
    ],
  },
  {
    name: "1.5x FastLane Points for using shMON as collateral",
    logo: "/points/fastlane.png",
    collateralVaults: [
      "0x6661a2b4008b70f22Ff84c2134ac6F51534E162d",
      "0xb6A4db1FeF7831F65827d9aF2Cb1e69F764eC123",
    ],
  },
  {
    name: "2x FastLane Points for depositing MON",
    logo: "/points/fastlane.png",
    collateralVaults: [
      "0x28bD4F19C812CBF9e33A206f87125f14E65dc8aA",
      "0x7B4BcAEAC5Eb67ae947903F24BBa660eE06A5231",
    ],
  },
  {
    name: "3x Kintsu Points ",
    logo: "/points/kintsu.png",
    collateralVaults: [
      "0xA8f093Cfb04a536Dbc6aa9BB94A2D617305a48F3",
      "0x9eA1b948186F9A8cfe375278d96363103f4fa42B",
      "0x3fE40329061A40f95416da42bB69E15d8eb83740",
    ],
  },
] as const
